import React from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

function useQueryParams() {
  const location = useLocation();
  const queryParams = React.useMemo(
    () => qs.parse(location.search, { ignoreQueryPrefix: true }),
    [location.search]
  );

  return queryParams;
}

export default useQueryParams;
